var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonRightBottomreact = function SvgButtonRightBottomreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 106.667 53.334"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1551",
    fill: "#2bd4db"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52861",
    d: "M106.667 0s-1.217 50.292-53.333 53.334V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 52862",
    d: "M53.334 0S52.117 50.292 0 53.334V0Z"
  }))));
};

export default SvgButtonRightBottomreact;